import { IEditableFormatObject } from "../../../../../../domain/editableFormat";
import { IXElementContentsObjectBean } from "../../../beans";

export class NameTranslator {
  from(bean: IXElementContentsObjectBean): string {
    return bean["@name"];
  }

  to(object: IEditableFormatObject): string {
    return object.name;
  }
}
